import React, {useEffect, useState} from 'react';
import {ISsqDataDocument} from "../../repositories/SsqDataRepository";
import {getHighlightedTextFromHtml} from "../../util/commonUtils";
import {AccountService} from "repositories/AccountService";
import {LanguageService} from "language/LanguageService";
import axios from "axios";
import parse from "html-react-parser";
import {langutil} from "language/langutil";
import clsx from 'clsx';
import {SsqImages} from "images/SsqImages";
import img_select_default from "images/community/select_default.svg";
import {useLoginInfo} from "hooks/useLoginInfo";
import {loginutil} from 'util/loginutil';
import {useLoginPopup} from "hooks/useLoginPopup";

interface Props {
  accountService?: AccountService;
  ssqDocument: ISsqDataDocument;
  getTranslation: Function;
  languageService: LanguageService;
  clickedTag: Function;
  displayLoginPopup: Function;
}

const SwServiceDocListItem = (props: Props) => {

  const [isEmployee, setIsEmployee] = useState(false);
  const [tags, setTags] = useState([]);
  const {country, lang} = langutil.splitLangCode(props.languageService.lang());
  const loginInfo = useLoginInfo();
  const showLoginPopup = useLoginPopup();

  useEffect(() => {
    setIsEmployee(props.ssqDocument.employ);
    axios.get('/api/guest/ssqData/doctaglist/taggrplist', {
      params: {
        docId: props.ssqDocument.id,
        lang: props.languageService.getLanguage()
      }
    }).then((res) => {
      setTags(res?.data || []);
    });
  }, []);

  let linkUrlArray = (props.ssqDocument.linkUrl || "").split(";");


  const httpsCheck1 = () => {
    if (linkUrlArray[1].toLowerCase().includes('https://') || linkUrlArray[1].toLowerCase().includes('http://')) {
      window.open(linkUrlArray[1], `_blank`);
    } else {
      window.open("http://" + linkUrlArray[1], `_blank`);
    }
  };

  const httpsCheck2 = () => {
    if (linkUrlArray[3].toLowerCase().includes('https://') || linkUrlArray[3].toLowerCase().includes('http://')) {
      window.open(linkUrlArray[3], `_blank`);
    } else {
      window.open("http://" + linkUrlArray[3], `_blank`);
    }
  };

  return (
    <>
      <li onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        if (!loginutil.hasDocViewAuth(loginInfo, props.ssqDocument.displayTarget)) {
          if (loginutil.islogin(loginInfo)) {
            loginutil.alertDocView(loginInfo, props.ssqDocument.displayTarget);
          } else {
            showLoginPopup(true);
          }
          return;
        }
        window.open(`/${country}/${lang}/service/software/document/${props.ssqDocument.id}`, "_blank");
      }}>
        <div className="store-card-body">
          <div className="store-card-header">
            <div className="logo-img">
              <img alt={'blog-img-url'} src={`/uploads/${props.ssqDocument.imageUrl}`}/>
            </div>
          </div>
          <div className="tag">
            {tags.map((tag, index) => (
              <span key={index} className={'cursor-pointer'} onClick={(e) => {
                e.stopPropagation();
                props.clickedTag(tag.tag);
              }}>#{tag?.tag}</span>
            ))}
          </div>
          <div className="store-title">
            <p className="title">
              {parse(getHighlightedTextFromHtml(props.ssqDocument.docTitle))}
              {props.ssqDocument.displayTarget == 20 &&
                <span className={clsx("lv-info", "lv-worker")}
                >{props.getTranslation("I18N_SOLUTION_EMPLOYEE_ONLY")}</span>
              }
              {props.ssqDocument.displayTarget == 15 &&
                <span className={clsx("lv-info", "partner")}
                >{props.getTranslation("I18N_PARTNER")}</span>
              }
            </p>
          </div>

          <div className="store-version">
            <div className="store-content-item">
              <p className="write-version">
                {parse(getHighlightedTextFromHtml(props.ssqDocument.sampleVersion))}
              </p>
            </div>
          </div>

          <div className="store-content">
            <div className="store-content-item">
              <p className="write-content">
                {parse(getHighlightedTextFromHtml(props.ssqDocument.docSampleSmry))}
              </p>
            </div>
          </div>

          <div className="swService-button">
            {
              linkUrlArray[2] === undefined ? null :
                <button className="swService-button-text1" onClick={(e) => {
                  e.stopPropagation();
                  httpsCheck1();
                }}>
                  {linkUrlArray[0]}
                  <img src={SsqImages.common.icon.pageLinkGray16()} alt="" className={"img-button1"}/>
                </button>
            }

            <button className={clsx("swService-button-text2")} onClick={(e) => {
              e.stopPropagation();
              linkUrlArray[2] === undefined ? httpsCheck1() : httpsCheck2();
            }}>{linkUrlArray[2] === undefined ? linkUrlArray[0] : linkUrlArray[2]}
              <img src={img_select_default} alt="" className={"img-button"}/>
            </button>

          </div>

        </div>
      </li>
    </>
  );
};

export default SwServiceDocListItem;

